<template>
  <div class="news-container" ref="container">
    <div ref="moveTarget" class="move-target">
      <div class="news-item" v-if="currentItem.url"><a :href="currentItem.url" target="_blank">{{currentItem.desc}}</a></div>
      <div class="news-item" v-if="currentItem.actionTransferUrl"><span>{{currentItem.desc}}</span></div>
      <div class="news-item" v-if="nextItem != null"><a :href="nextItem.url" target="_blank">{{nextItem.desc}}</a></div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'NewsBroadcast',
  props: {
    items: Array
  },
  data() {
    let items = this.items;
    return {
      current: 0,
      max: items.length,
      height: 0,
      currentItem: items[0],
      nextItem: items[1]
    };
  },
  methods: {
    doMove() {
      let moveTarget = this.$refs.moveTarget;
      let task = this.$timer.interval(() => {
        let top = parseInt(moveTarget.style.top, 10) || 0;
        top -= 4;
        moveTarget.style.top = top + 'px';
        if (top <= -this.height) {
          task.release();
          moveTarget.style.top = '0px';
          this.current++;
          if (this.current >= this.max) {
            this.current = 0;
          }
          let nextIndex = this.current + 1;
          if (nextIndex >= this.max) {
            nextIndex = 0;
          }
          this.currentItem = this.items[this.current];
          this.nextItem = this.items[nextIndex];
          this.replay();
        }
      }, 30);
    },
    actionPerform(item) {
      if (item.actionPerform) {
        item.actionPerform();
        return;
      }
      this.$emit('action', item);
    },
    replay() {
      this.$timer.once(() => {
        this.doMove();
      }, 5000);
    },
    init() {
      this.height = this.$refs.container.offsetHeight;
      let moveTarget = this.$refs.moveTarget;
      Array.prototype.forEach.call(moveTarget.querySelectorAll('.news-item'), (control) => {
        control.style.lineHeight = this.height + 'px';
      });
    }
  },
  mounted() {
    this.init();
    this.replay();
  }
};
</script>
<style lang="less" scoped>
  .news-container {
    height: 100%;
    overflow: hidden;
    position: relative;
    .move-target {
      height: 100%;
      position: relative;
    }
    .news-item {
      height: 100%;
      a {
        cursor: pointer;
        font-size: 15px;
        color: #212121;
        text-decoration: none;
      }
      span {
        font-size: 15px;
        color: #212121;
        text-decoration: none;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/open/common/NewsBroadcast.vue